// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.StringFilterValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { StringFilterOperation } from "abweb/dto/generated/inputargs/StringFilterOperation";
import { FilterValue } from "abweb/dto/inputargs/FilterValue";
export class StringFilterValueBase extends FilterValue {
  /** Do NOT invoke directly, instead use strongly typed createStringFilterValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.StringFilterValue";
  }
  initFromJson(json, deserializeContext) {
    this.initStringFilterValue(json.componentGuid != null ? json.componentGuid : null, json.isCaseSensitive != null ? json.isCaseSensitive : null, json.isOpNegated != null ? json.isOpNegated : null, json.op != null ? StringFilterOperation.fromJson(json.op) : null, json.value != null ? json.value : null);
  }
  initStringFilterValue(componentGuid, isCaseSensitive, isOpNegated, op, value) {
    this.initFilterValue(componentGuid);
    this._isCaseSensitive = isCaseSensitive;
    this._isOpNegated = isOpNegated;
    this._op = op;
    this._value = value;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["isCaseSensitive"] = this._isCaseSensitive;
    retVal["isOpNegated"] = this._isOpNegated;
    retVal["op"] = this._op;
    if (this._value != null) {
      retVal["value"] = this._value;
    }
    return retVal;
  }
  get isCaseSensitive() {
    return this._isCaseSensitive;
  }
  set isCaseSensitive(value) {
    this._isCaseSensitive = value;
  }
  get isOpNegated() {
    return this._isOpNegated;
  }
  set isOpNegated(value) {
    this._isOpNegated = value;
  }
  get op() {
    return this._op;
  }
  set op(value) {
    this._op = value;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
//# sourceMappingURL=StringFilterValueBase.js.map
